module.exports = __webpack_public_path__ + "stylesheets/footer_5f42b9b37fa1d9288a06588a0b8e2f91.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/footer.less
// module id = fAML
// module chunks = 153